export default __webpack_public_path__ + "a21277049a5e22f0da4452f8263590a8.svg";